import React from 'react';

import Link from '@components/link/Link.tsx';
import getCurrentPage from '@functions/getCurrentPage.ts';

import I from '../types.ts';

const renderNav: I['renderNav'] = function () {
    const { storePages } = this.props;
    const nav = this.getNav();

    return (
        <div className="publicTop__nav _row">
            {nav.map((item) => {
                const isCurrent =
                    getCurrentPage({
                        storePages,
                        filter: (page) => page.parentName === 'public',
                    }) === item.name;

                return (
                    <div
                        className={`publicTop__navItem _col ${isCurrent ? '_current' : ''}`}
                        key={item.name}
                    >
                        <Link className="publicTop__navLink" pageName={item.name}>
                            {item.contentOfLink}
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default renderNav;
